/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_SubtitleInputs */

const en_pricing_subtitle = /** @type {(inputs: Pricing_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade for premium AI and more room to plan.`)
};

const id_pricing_subtitle = /** @type {(inputs: Pricing_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade untuk AI premium dan ruang perencanaan lebih besar.`)
};

/**
* | output |
* | --- |
* | "Upgrade for premium AI and more room to plan." |
*
* @param {Pricing_SubtitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pricing_subtitle = /** @type {((inputs?: Pricing_SubtitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_SubtitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pricing_subtitle(inputs)
	return en_pricing_subtitle(inputs)
});